// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__V0U_w","file":"styles_file__1Wbbi"};